/** @typedef {primary} #5046E8 */

export const primitives = {
    /**  'Albert Sans', sans-serif */
    primaryFontFamily: "'Albert Sans', sans-serif",
    /** #000000 */
    primaryA: '#000000',
    /** #FFFFFF */
    primaryB: '#FFFFFF',
    /** #5046E8 */
    primary: '#5046E8',
    /** #F7F7FF */
    primary50: '#F7F7FF',
    /** #DDE0FF */
    primary100: '#DDE0FF',
    /** #9AA1FF */
    primary200: '#9AA1FF',
    /** #7882FF */
    primary300: '#7882FF',
    /** #5046E8 */
    primary400: '#5046E8',
    /** #5046E8 */
    primary500: '#5046E8',
    /** #5046E8 */
    primary600: '#5046E8',
    /** #5046E8 */
    primary700: '#5046E8',

    /** #000000 */
    accent: '#000000',
    /** #cacaca */
    accent50: '#cacaca',
    /** #a6a6a6 */
    accent100: '#a6a6a6',
    /** #949494 */
    accent200: '#949494',
    /** #717171 */
    accent300: '#717171',
    /** #454545 */
    accent400: '#454545',
    /** #363636 */
    accent500: '#363636',
    /** #272727 */
    accent600: '#272727',
    /** #171717 */
    accent700: '#171717',

    /** #FFFFFF */
    white: '#FFFFFF',
    /** #FFFFFF */
    black: '#000000',

    /** #F6F6F6 */
    mono100: '#F6F6F6',
    /** #EAECF0 */
    mono200: '#EAECF0',
    /** #B3BBC7 */
    mono300: '#B3BBC7',
    /** #667085 */
    mono400: '#667085',
    /** #434B5C */
    mono500: '#434B5C',
    /** #000000 */
    mono600: '#000000',
    /** #000000 */
    mono700: '#000000',
    /** #000000 */
    mono800: '#000000',
    /** #000000 */
    mono900: '#000000',
    /** #000000 */
    mono1000: '#000000',

    /** #D42434 */
    negative: '#D42434',
    /** #FFF2F5 */
    negative50: '#FFF2F5',
    /** #FFF2F5 */
    negative100: '#FFF2F5',
    /** #FFF2F5 */
    negative200: '#D42434',
    /** #FFF2F5 */
    negative300: '#D42434',
    /** #FFF2F5 */
    negative400: '#D42434',
    /** #FFF2F5 */
    negative500: '#D42434',
    /** #FFF2F5 */
    negative600: '#D42434',
    /** #D42434 */
    negative700: '#D42434',

    /** #B54708 */
    warning: '#B54708',
    /** #FFFAEB */
    warning50: '#FFFAEB',
    /** #FFC369 */
    warning100: '#FFC369',
    /** #FFC043 */
    warning200: '#FFC043',
    /** #FFC043 */
    warning300: '#FFC043',
    /** #FFC043 */
    warning400: '#FFC043',
    /** #FFC043 */
    warning500: '#FFC043',
    /** #FF9900 */
    warning600: '#FF9900',
    /** #B54708 */
    warning700: '#B54708',

    /** #027A48 */
    positive: '#027A48',
    /** #E6FFE7 */
    positive50: '#E6FFE7',
    /** #E6FFE7 */
    positive100: '#E6FFE7',
    /** #039855 */
    positive200: '#039855',
    /** #039855 */
    positive300: '#039855',
    /** #039855 */
    positive400: '#039855',
    /** #039855 */
    positive500: '#039855',
    /** #039855 */
    positive600: '#039855',
    /** #027A48 */
    positive700: '#027A48',

    /** #FFF5F5 */
    red50: '#FFF5F5',
    /** #FFD5D8 */
    red200: '#FFD5D8',
    /** #FF808B */
    red600: '#FF808B',
    /** #FE2C3E */
    red700: '#FE2C3E',
    /** #FE2C3E  */
    red: '#FE2C3E',

    /** #F2FFF7 */
    green50: '#F2FFF7',
    /** #CCFFDD */
    green200: '#CCFFDD',
    /** #6EE998 */
    green400: '#6EE998',
    /** #8CF7B036 */
    green500: '#8CF7B036',
    /** #66FF9A */
    green600: '#66FF9A',
    /** #00FF57 */
    green700: '#00FF57',

    /** #F7F7FF */
    blue50: '#F7F7FF',
    /** #DDE0FF */
    blue100: '#DDE0FF',
    /** #9AA1FF */
    blue200: '#9AA1FF',
    /** #C882FF */
    blue300: '#C882FF',

    /** #FFFFF2 */
    yellow50: '#FFFFF2',
    /** #FEFFCC */
    yellow200: '#FEFFCC',
    /** #FCFF66 */
    yellow600: '#FCFF66',
    /** #FAFF00 */
    yellow700: '#FAFF00',
    /** #FAFF00 */
    yellow: '#FAFF00',

    /** #FFF6F2 */
    orange50: '#FFF6F2',
    /** #FFDBCC */
    orange200: '#FFDBCC',
    /** #FF9466*/
    orange600: '#FF9466',
    /** #FF4D00*/
    orange700: '#FF4D00',
    /** #FF4D00*/
    orange: '#FF4D00',

    /** #FCF9FF */
    purple50: '#FCF9FF',
    /** #F4E6FF */
    purple200: '#F4E6FF',
    /** #DEB4FF */
    purple600: '#DEB4FF',
    /** #C882FF */
    purple700: '#C882FF',
    /** #C882FF */
    purple: '#C882FF',

    /** #FFF8FF */
    pink50: '#FFF8FF',
    /** #FFE1FE */
    pink200: '#FFE1FE',
    /** #FFA7FB */
    pink600: '#FFA7FB',
    /** #FF6CF9 */
    pink700: '#FF6CF9',

    /** #A8E0FF */
    booking700: '#A8E0FF'
}

export default primitives
